import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { connect, useDispatch } from 'react-redux';
import { removedExpiredAdsLisitingRequest } from './redux/removedExpiredAdsDispatcher';
import { imageBaseUrls } from '../../constant/ApiUrls';

function RemovedExpiredAdsListingTable({ removedExpiredAdsListing, loading, totalRemovedExpiredAds }) {
  const dispatch = useDispatch();

  // Local state for pagination
  const [page, setPage] = useState(0); // DataGrid page is 0-indexed
  const [pageSize, setPageSize] = useState(10);

  // Fetch data whenever page or pageSize changes
  useEffect(() => {
    dispatch(removedExpiredAdsLisitingRequest(page + 1, pageSize)); // API page is 1-indexed
  }, [dispatch, page, pageSize]);

  // Table columns
  const removedExpiredAdsColumns = [
    {
      field: 'id',
      headerName: 'NO',
      width: 60,
      renderCell: (params) =>
        params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,
    },

   {
  field: "images",
  headerName: "Image",
  width: 100,
  sortable: false,
  renderCell: (params) => {
    let imgArray = [];
    try {
      imgArray = JSON.parse(params.value); // Parse stringified JSON
    } catch (e) {
      console.error("Invalid image JSON:", params.value);
    }

    const firstImg = imgArray.length > 0 ? imgArray[0] : null;

    return firstImg ? (
      <img
        src={`${imageBaseUrls(firstImg)}`}
        alt="Ad"
        style={{ width: 60, height: 60, borderRadius: "10px", objectFit: "cover" }}
      />
    ) : (
      <span>No Image</span>
    );
  },
},
    {
      field: 'title',
      headerName: 'Title',
      width: 300,
    },
    {
      field: 'price',
      headerName: 'Price',
      width: 150,
    },


{
  field: "sold_at",
  headerName: "Removed/Expired At",
  width: 200,
  renderCell: (params) => {
    const soldAt = params.row.status===4||params.row.status===5?params.row.updated_at:params.row.expiry;

    if (!soldAt) {
      return <span>-</span>;
    }

    const date = new Date(soldAt);

    // If invalid date
    if (isNaN(date.getTime())) {
      return <span>-</span>;
    }

    const formattedDate = date.toLocaleString(); // or toLocaleDateString()

    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h6>{formattedDate}</h6>
      </div>
    );
  },
},


  {
  field: "status",
  headerName: "Status",
  width: 200,
  renderCell: (params) => {
    const status = params.row.status;


    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h6>{status===4?"Deleted":status===5?"Sold Else Where":"Expired"}</h6>
      </div>
    );
  },
}




//     {
//   field: "actions",
//   headerName: "Actions",
//   width: 120,
//   sortable: false,
//   renderCell: (params) => (
//     <a
//       href={`${webSiteUrl}ads/${params.row.id}`}
//       target="_blank"
//       rel="noopener noreferrer"
//       style={{
//         textDecoration: "none",
//         color: "#1976d2",
//         fontWeight: "500",
//         border: "1px solid #1976d2",
//         borderRadius: "6px",
//         padding: "4px 8px",
//         fontSize: "12px",
//       }}
//     >
//       View
//     </a>
//   ),
// }

    // You can add more columns here
  ];

  return (
    <Paper sx={{ height: '95%', width: '100%' }}>
      <DataGrid
        rows={(removedExpiredAdsListing || []).map((item, index) => ({
          id: item.id || index,
          ...item,
        }))}
        columns={removedExpiredAdsColumns}
        pagination
        paginationMode="server"
        paginationModel={{ page, pageSize }} // ✅ Controlled pagination
        onPaginationModelChange={(model) => {
          setPage(model.page);
          setPageSize(model.pageSize);
        }}
        pageSizeOptions={[5, 10, 25, 50]} // ✅ correct prop for dropdown
        rowCount={totalRemovedExpiredAds || 0}
        rowHeight={60}
        loading={loading}
        checkboxSelection={false}
        sx={{ border: 0 }}
      />

    </Paper>
  );
}

const mapStateToProps = (state) => ({
  removedExpiredAdsListing: state.removedExpiredAdsReducer.removedExpiredAdsListing,
  loading: state.removedExpiredAdsReducer.loading,
  totalRemovedExpiredAds: state.removedExpiredAdsReducer.totalRemovedExpiredAds, // ✅ map total
});

export default connect(mapStateToProps)(RemovedExpiredAdsListingTable);
